import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class LoadingSpinnerService {

    isLoading = false;

    constructor(
        public loadingController: LoadingController,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) { }

    async present() {
        // Overlay Ionic depende de DOM: no server (SSR/prerender) é no-op.
        if (!isPlatformBrowser(this.platformId)) return;
        this.isLoading = true;
        return await this.loadingController.create({
        }).then(loadingModal => {
            loadingModal.present().then(() => {
                if (!this.isLoading) {
                    loadingModal.dismiss();
                }
            });
        });
    }

    async dismiss() {
        if (!isPlatformBrowser(this.platformId)) return;
        this.isLoading = false;
        // Ionic 6+: dismiss() sem overlay apresentado REJEITA ("overlay does not
        // exist") — no Ionic 5 resolvia silencioso. A rejection não tratada vaza
        // como uncaught e derruba testes E2E (Cypress falha o teste corrente).
        const top = await this.loadingController.getTop();
        return top ? await top.dismiss() : undefined;
    }
}